/* unplugin-vue-components disabled */import { render } from "./personal_profile.vue?vue&type=template&id=16056a5e&scoped=true"
import script from "./personal_profile.vue?vue&type=script&lang=js"
export * from "./personal_profile.vue?vue&type=script&lang=js"

import "./personal_profile.vue?vue&type=style&index=0&id=16056a5e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16056a5e"]])

export default __exports__